import { createAction } from "@reduxjs/toolkit";


export const setToggleSidebar = createAction("toggle/setToggle")
export const setToggleMailing = createAction("toggle/setToggleMailing")